import React, {useEffect, useState} from "react";
import {useStore, useFetch} from "@vigo/hooks";
import {Table, Col, Divider, Form, Input, Row, Result, Button, Select, Switch} from "antd";
import {useTranslation} from "react-i18next";
import {useFormik} from "formik";
import {useObserver} from "mobx-react-lite";
import {CallbackEdit} from "./CallbackEdit/CallbackEdit";
import {useHistory} from "react-router-dom";
import {IntegratorList} from "./IntegratorList";
import {diffObject} from "../../../utils/helpers";
import {MaskedInput} from "antd-mask-input";

export const EditSupplierPage = ({supplierId, companyId}) => {
    const stores = useStore();
    const history = useHistory();
    const [refetch, setRefetch] = useState(false);
    const {t} = useTranslation();
    const isNew = !Boolean(supplierId);

    const formik = useFormik({
        initialValues: {
            name: "",
            authorizedPhone: "",
            authorizedName: "",
            integratorId: "",
            username: "",
            companyId: companyId ?? "",
            properties: [],
            isTest: false,
            email: "",
            callback: {}
        },
        //validationSchema: newPasswordFormValidation,
        onSubmit: async () => {
            setRefetch(prev => !prev);
        }
    });
    const [, supplierInfo] = useFetch({
        defaultDataValue: {},
        fetchFn: stores.supplierStore.supplierInfo.bind(null, {
            supplierId
        }),
        initialCall: true,
        condition: supplierId !== undefined,
        showLoading: true,
        dependencies: [],
        callbackFunc: result => {
            if (!result) {
                history.goBack();
                return;
            }
            formik.setValues(JSON.parse(JSON.stringify(result)));
        }
    });

    const {
        handleSubmit,
        values,
        isSubmitting,
        errors,
        setFieldValue,
        touched,
        handleChange
    } = formik;

    useFetch({
        defaultDataValue: {},
        fetchFn: (isNew
            ? stores.supplierStore.createSupplier
            : stores.supplierStore.updateSupplier
        ).bind(null, {
            supplierId,
            ...diffObject(supplierInfo, values)
        }),
        initialCall: false,
        showLoading: true,
        dependencies: [refetch],
        callbackFunc: (result) => {
            if(result) {
                history.goBack();
            }
        }
    });

    return useObserver(() => (
        <div>
            <h1>Tedarikçi</h1>
            <Form
                autoComplete="off"
                onFinish={handleSubmit}
                labelCol={{span: 24}}
                wrapperCol={{span: 24}}
            >
                <Row type="flex" justify="center">
                    <Col span={20}>
                        <Form.Item
                            label={t("fields.integrator", {ns: "supplierDetail"})}
                            help={
                                errors.integratorId && touched.integratorId
                                    ? errors.integratorId
                                    : null
                            }
                        >
                            <Col sm={24} md={24}>
                                <IntegratorList
                                    onSelect={value => {
                                        setFieldValue("integratorId", value);
                                    }}
                                    disabled={supplierId}
                                    value={values.integratorId}
                                />
                            </Col>
                        </Form.Item>
                        <Form.Item
                            label={t("fields.authorizedName", {ns: "supplierDetail"})}
                            help={
                                errors.authorizedName && touched.authorizedName
                                    ? errors.authorizedName
                                    : null
                            }
                        >
                            <Col sm={24} md={24}>
                                <Input
                                    name="authorizedName"
                                    value={values.authorizedName}
                                    onChange={handleChange}
                                    data-testid={`transferModal_textArea`}
                                />
                            </Col>
                        </Form.Item>
                        <Form.Item
                            label={t("fields.authorizedPhone", {ns: "supplierDetail"})}
                            help={
                                errors.authorizedPhone && touched.authorizedPhone
                                    ? errors.authorizedPhone
                                    : null
                            }
                        >
                            <Col sm={24} md={24}>
                                <MaskedInput
                                    placeholder="0(555)-333-4444"
                                    mask="1(111)-111-1111"
                                    name="authorizedPhone"
                                    data-testid="authorizedPhone"
                                    value={values.authorizedPhone}
                                    onChange={handleChange}
                                />
                            </Col>
                        </Form.Item>
                        <Form.Item
                            label={t("fields.email", {ns: "supplierDetail"})}
                            help={
                                errors.email && touched.email
                                    ? errors.email
                                    : null
                            }
                        >
                            <Col sm={24} md={24}>
                                <Input
                                    type="email"
                                    name="email"
                                    value={values.email}
                                    onChange={handleChange}
                                    data-testid={`transferModal_textArea`}
                                />
                            </Col>
                        </Form.Item>
                        <Form.Item
                            label={t("fields.isTest", {ns: "supplierDetail"})}
                            help={
                                errors.isTest && touched.isTest
                                    ? errors.isTest
                                    : null
                            }
                        >
                            <Switch
                                checkedChildren="On"
                                unCheckedChildren="Off"
                                checked={values?.isTest ?? false}
                                name="isTest"
                                onChange={() => {
                                    setFieldValue("isTest", !values?.isTest);
                                }}
                                data-testid={`transferModal_textArea`}
                            />
                        </Form.Item>
                        <Col
                                sm={24}
                                md={24}
                                style={{
                                    margin: 10,
                                    border: "1px solid #d9d9d9",
                                    padding: 10
                                }}
                            >
                                <Row style={{
                                    marginBottom: 20
                                }}>
                                    {t("fields.callback", {ns: "supplierDetail"})}
                                    <Switch
                                        checkedChildren="On"
                                        unCheckedChildren="Off"
                                        checked={values.callback?.active ?? false}
                                        name="callback.active"
                                        onChange={() => {
                                            setFieldValue(
                                                "callback.active",
                                                !values.callback?.active
                                            );
                                        }}
                                        style={{
                                            marginLeft: 10
                                        }}
                                        data-testid={`transferModal_textArea`}
                                    />
                                </Row>
                                <Form.Item
                                    label={t("fields.method", {ns: "supplierDetail"})}
                                    help={
                                        errors?.callback?.method && touched?.callback?.method
                                            ? errors?.callback?.method
                                            : null
                                    }
                                    style={{
                                        marginBottom: 5
                                    }}
                                >
                                    <Col sm={24} md={24}>
                                        <Select
                                            name="callback.method"
                                            value={values.callback?.method ?? ""}
                                            onChange={value =>
                                                setFieldValue("callback.method", value)
                                            }
                                            data-testid={`transferModal_textArea`}
                                        >
                                            <Select.Option value="GET">GET</Select.Option>
                                            <Select.Option value="POST">POST</Select.Option>
                                            <Select.Option value="PUT">PUT</Select.Option>
                                            <Select.Option value="DELETE">DELETE</Select.Option>
                                        </Select>
                                    </Col>
                                </Form.Item>
                                <Form.Item
                                    label={t("fields.url", {ns: "supplierDetail"})}
                                    help={
                                        errors?.callback?.url && touched?.callback?.url
                                            ? errors?.callback?.url
                                            : null
                                    }
                                    style={{
                                        marginBottom: 5
                                    }}
                                >
                                    <Col sm={24} md={24}>
                                        <Input
                                            name="callback.url"
                                            value={values.callback?.url ?? ""}
                                            onChange={handleChange}
                                            data-testid={`transferModal_textArea`}
                                        />
                                    </Col>
                                </Form.Item>
                                <h3>Header</h3>
                                <Form.Item
                                    label={t("fields.header", {ns: "supplierDetail"})}
                                    help={
                                        errors?.callback?.tokenHeader && touched?.callback?.tokenHeader
                                            ? errors.newPassword
                                            : null
                                    }
                                    style={{
                                        marginBottom: 5
                                    }}
                                >
                                    <Col sm={24} md={24}>
                                        <Input
                                            name="callback.tokenHeader"
                                            value={values.callback?.tokenHeader ?? ""}
                                            onChange={handleChange}
                                            data-testid={`transferModal_textArea`}
                                        />
                                    </Col>
                                </Form.Item>
                                <Form.Item
                                    label={t("fields.token", {ns: "supplierDetail"})}
                                    help={
                                        errors?.callback?.token && touched?.callback?.token
                                            ? errors?.callback?.token
                                            : null
                                    }
                                    style={{
                                        marginBottom: 5
                                    }}
                                >
                                    <Col sm={24} md={24}>
                                        <Input
                                            name="callback.token"
                                            value={values.callback?.token ?? ""}
                                            onChange={handleChange}
                                            data-testid={`transferModal_textArea`}
                                        />
                                    </Col>
                                </Form.Item>
                                <h3>Body</h3>
                                <CallbackEdit
                                    callback={values.callback?.body ?? []}
                                    setCallback={value => {
                                        const callback = values.callback;
                                        callback.body = value;
                                        setFieldValue("callback", callback);
                                    }}
                                />
                            </Col>
            <div  style={{
                display: "flex",
                justifyContent: "flex-end"
            }} >
            <Button disabled={isSubmitting} type="primary" htmlType="submit">
                {t("actions.save", {ns: "common"})}
            </Button>
                            </div>
                    </Col>
                </Row>
            </Form>
        </div>
    ));
};
